/** @format — AG-UI stream helpers (tools, throttled text patches) */

/** Internal routing — never show in StreamToolCalls UI */
export const HIDDEN_STREAM_TOOLS = new Set(["transfer_to_agent"]);

/** Tools that indicate an AG-UI (cards) turn */
export const AGUI_SIGNAL_TOOLS = new Set([
  "get_shipping_quote",
  "get_shipping_quote_by_details",
  "get_location_from_zip",
  "get_current_user_profile",
  "initiate_vehicle_posting_payment",
  "create_shipment_unified",
  "search_user_shipments",
  "search_user_bookings_advanced",
  "get_saved_tracking_state_for_agent",
  "summarize_tracking_state",
]);

export function isHiddenStreamTool(name) {
  return HIDDEN_STREAM_TOOLS.has(name);
}

export function isAguiSignalTool(name) {
  return AGUI_SIGNAL_TOOLS.has(name);
}

export function filterVisibleStreamTools(tools = []) {
  return tools.filter((t) => t?.name && !isHiddenStreamTool(t.name));
}

/** Throttle text patches (~12fps) — smooth growth without layout thrash */
export function createThrottledTextPatch(onPatch, intervalMs = 80) {
  let latest = "";
  let timerId = null;

  const flushPatch = () => {
    timerId = null;
    onPatch({ text: latest, streamStatus: "writing" });
  };

  return {
    push(text) {
      latest = text;
      if (timerId != null) return;
      timerId = window.setTimeout(flushPatch, intervalMs);
    },
    flush() {
      if (timerId != null) {
        window.clearTimeout(timerId);
        timerId = null;
      }
      return latest;
    },
    cancel() {
      if (timerId != null) {
        window.clearTimeout(timerId);
        timerId = null;
      }
    },
  };
}
